import { SELL_TYPE_IDS } from '@common/constants';
const {
  createSelector
} = RTK;
export const selectIsSpelombud = createSelector(state => state.User, User => {
  let sellTypeId = User?.retailer?.sellTypeId;
  if (!sellTypeId) {
    sellTypeId = SELL_TYPE_IDS.SPEL_LOTT;
  }
  return [SELL_TYPE_IDS.SPEL, SELL_TYPE_IDS.SPEL_LOTT].includes(sellTypeId);
});
export const selectFolderIdsForSellType = createSelector(state => state.User, (_state, folders) => folders, (User, folders = {}) => {
  let sellTypeId = User?.retailer?.sellTypeId;
  if (!sellTypeId) {
    sellTypeId = SELL_TYPE_IDS.SPEL_LOTT;
  }
  return [folders.common, sellTypeId === SELL_TYPE_IDS.LOTT ? folders.lottombud : undefined, [SELL_TYPE_IDS.SPEL_LOTT, SELL_TYPE_IDS.SPEL].includes(sellTypeId) ? folders.spelombud : undefined].filter(Boolean);
});